var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 5.5C9.75 3.70507 8.29493 2.25 6.5 2.25C4.70507 2.25 3.25 3.70507 3.25 5.5C3.25 7.29493 4.70507 8.75 6.5 8.75C7.45963 8.75 8.32211 8.33409 8.91703 7.6727L11.6343 9.15487L14.6749 10.8923C14.4045 11.3664 14.25 11.9152 14.25 12.5C14.25 12.7963 14.2897 13.0834 14.364 13.3562L8.91703 16.3273C8.32211 15.6659 7.45963 15.25 6.5 15.25C4.70507 15.25 3.25 16.7051 3.25 18.5C3.25 20.2949 4.70507 21.75 6.5 21.75C8.29493 21.75 9.75 20.2949 9.75 18.5C9.75 18.2036 9.71033 17.9166 9.63602 17.6438L15.083 14.6727C15.6779 15.3341 16.5404 15.75 17.5 15.75C19.2949 15.75 20.75 14.2949 20.75 12.5C20.75 10.7051 19.2949 9.25 17.5 9.25C16.8493 9.25 16.2433 9.44122 15.7351 9.77052L12.3657 7.84514L9.63602 6.35625C9.71033 6.08344 9.75 5.79635 9.75 5.5ZM6.5 3.75C7.4665 3.75 8.25 4.5335 8.25 5.5C8.25 6.4665 7.4665 7.25 6.5 7.25C5.5335 7.25 4.75 6.4665 4.75 5.5C4.75 4.5335 5.5335 3.75 6.5 3.75ZM17.5 10.75C18.4665 10.75 19.25 11.5335 19.25 12.5C19.25 13.4665 18.4665 14.25 17.5 14.25C16.5335 14.25 15.75 13.4665 15.75 12.5C15.75 11.5335 16.5335 10.75 17.5 10.75ZM8.25 18.5C8.25 17.5335 7.4665 16.75 6.5 16.75C5.5335 16.75 4.75 17.5335 4.75 18.5C4.75 19.4665 5.5335 20.25 6.5 20.25C7.4665 20.25 8.25 19.4665 8.25 18.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.38a3f5217d82b670f8515119107dc120.svg";
export { ForwardRef as ReactComponent };